var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41284 15.8864L0 21.0449L5.27891 19.6606C6.73344 20.4537 8.37095 20.8718 10.0374 20.8724H10.0418C15.53 20.8724 19.9976 16.4061 20 10.9176C20.0009 8.25756 18.9664 5.75642 17.0861 3.87475C15.2058 1.99308 12.7056 0.956493 10.0419 0.955139C4.55279 0.955139 0.0859426 5.42064 0.0836418 10.9096C0.0815332 12.6565 0.540006 14.3732 1.41284 15.8864ZM1.76003 10.8833C1.76166 6.32133 5.47451 2.60983 10.04 2.60983C11.1274 2.60725 12.2044 2.82038 13.2089 3.23688C14.2133 3.65338 15.1251 4.26497 15.8916 5.03625C16.6623 5.80333 17.2732 6.71568 17.689 7.72048C18.1047 8.72528 18.317 9.80256 18.3135 10.89C18.3118 15.4522 14.5989 19.1641 10.0369 19.1641H10.0338C8.54828 19.1633 7.09159 18.7646 5.82113 18.0106L5.51864 17.8314L2.38599 18.6528L3.22228 15.5997L3.02535 15.2867C2.19646 13.9677 1.75779 12.4411 1.76003 10.8833Z",
    fill: "#CCD6E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18656 6.46842C7.00468 6.06507 6.8133 6.0569 6.64052 6.04992L6.17539 6.04425C6.01357 6.04425 5.75065 6.10487 5.52838 6.34733C5.30611 6.58979 4.67903 7.17578 4.67903 8.36765C4.67903 9.55953 5.54858 10.7112 5.66974 10.873C5.79091 11.0348 7.34838 13.5587 9.81486 14.5297C11.8645 15.3367 12.2816 15.1762 12.7267 15.1358C13.1717 15.0955 14.1623 14.5499 14.3644 13.9842C14.5665 13.4185 14.5666 12.9338 14.506 12.8325C14.4454 12.7311 14.2836 12.6709 14.0408 12.5497C13.7979 12.4285 12.6051 11.8425 12.3827 11.7616C12.1603 11.6807 11.9986 11.6405 11.8367 11.8829C11.6747 12.1254 11.2102 12.6708 11.0686 12.8325C10.927 12.9942 10.7856 13.0145 10.5428 12.8934C10.2999 12.7723 9.51854 12.5164 8.59145 11.6911C7.87013 11.0489 7.38322 10.2559 7.24147 10.0136C7.09971 9.77129 7.22642 9.64004 7.34811 9.51934C7.45701 9.41076 7.59071 9.23642 7.71227 9.09503C7.83383 8.95364 7.87383 8.85257 7.9546 8.69115C8.03538 8.52973 7.99513 8.38794 7.93441 8.26685C7.8737 8.14575 7.40223 6.94755 7.18656 6.46842Z",
    fill: "#CCD6E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.813d7f7dfae6775f5e2925e963a17ed2.svg";
export { ForwardRef as ReactComponent };